import {createBrowserHistory} from 'history';
import pageTracker from './ga/PageTracker';

const history = createBrowserHistory();

// track pageviews
pageTracker(history);

export default history;
